export function openExternalWebPage(url: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const safariViewController = (window as any).SafariViewController;
  if (typeof safariViewController !== 'undefined') {
    safariViewController.show({
      url,
      hidden: false,
      animated: true,
      tintColor: '#ffffff',
      barColor: '#00a9ab',
      controlTintColor: '#ffffff',
    });
    return;
  }
  window.open(url, '_blank');
}
